import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "typography"
    }}>{`Typography`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-body.md"
        }}>{`sp-body`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-detail.md"
        }}>{`sp-detail`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-heading.md"
        }}>{`sp-heading`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "sp-label.md"
        }}>{`sp-label`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      